import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagPopupComponent } from './tag-popup/tag-popup.component';
import { TagListComponent } from './tag-list/tag-list.component';
import { MaterialsModule } from '../../modules/material.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PopoverModule } from '../popover/popover.module';
import { InputBoxModule } from '../input-box/input-box.module';
import { FormFieldsModule } from '../form-fields/form-fields.module';
import { ButtonsModule } from '../buttons/buttons.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DxScrollViewModule } from 'devextreme-angular';

@NgModule({
  declarations: [TagPopupComponent, TagListComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaterialsModule,
    PopoverModule,
    DxScrollViewModule,
    InputBoxModule,
    FormFieldsModule,
    TranslateModule.forChild(),
    ButtonsModule,
    MatProgressSpinnerModule,
  ],
  exports: [TagPopupComponent, TagListComponent],
})
export class TagModule {}
